import { SECURITY_EVENTS, EVENT_SEVERITY } from './constants';

export function subscribeVisibility(logSecurityEvent, { enabled = true } = {}) {
  if (typeof document === 'undefined' || !enabled) return () => {};
  let hiddenAt = null;

  const handler = () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
      logSecurityEvent({
        type: SECURITY_EVENTS.TAB_HIDDEN,
        severity: EVENT_SEVERITY[SECURITY_EVENTS.TAB_HIDDEN],
        message: 'Exam page became hidden'
      });
      return;
    }
    if (document.visibilityState === 'visible') {
      const awayDurationMs = hiddenAt != null ? Date.now() - hiddenAt : 0;
      hiddenAt = null;
      logSecurityEvent({
        type: SECURITY_EVENTS.TAB_VISIBLE,
        severity: EVENT_SEVERITY[SECURITY_EVENTS.TAB_VISIBLE],
        message: 'Candidate returned to exam page',
        metadata: { awayDurationMs }
      });
    }
  };

  document.addEventListener('visibilitychange', handler);
  return () => document.removeEventListener('visibilitychange', handler);
}
